<template>
	<div class="content">
		<h1 class="content__title">Бинарный опцион</h1>
		<div class="content__inner">
			<form class="form-rate" @submit.prevent="checkForm">
				<div class="form-rate__place-bet place-bet">
					<h2 class="place-bet__title">Выберите валюту и введите сумму ставки:</h2>
					<div class="place-bet__content">
						<div class="place-bet__controls place-bet__controls--amount">
							<div class="form-control">
								<span class="form-control__label">Валюта</span>
								<select class="form-control__select select" name="currency_name" v-model="currency"
								        :disabled="bidAccepted" required @:change="checkAmountInput">
									<option v-for="cur in currencies" :value="cur.code" :key="cur.code"
									        v-html="cur.symbol + ' ' + cur.code"></option>
								</select>
							</div>
							<div class="form-control">
								<span class="form-control__label">Сумма</span>
								<input type="text" class="form-control__input input" name="bet_amount" v-model="amount"
								       :class="{ 'is-invalid': errors.length }" @keyup="checkAmountInput" :disabled="bidAccepted"
								       required>
								<div v-if="errors.length" class="form-control__error">
									<span v-for="error in errors" :key="error">{{ error }}</span>
								</div>
							</div>
						</div>
						<p class="place-bet__subtitle">После следующего изменения котировок индекс биткойна к этой валюте
							пойдет:</p>
						<div class="place-bet__controls">
							<div class="form-control">
								<div class="radio">
									<input type="radio" name="bitcoin_rate" id="bitcoin-rate-up" value="up" v-model="direction"
									       :disabled="bidAccepted" required>
									<label for="bitcoin-rate-up"><img src="../assets/icons/icon-arrow-up-solid.svg" alt="">
										Вверх</label>
								</div>
							</div>
							<div class="form-control">
								<div class="radio">
									<input type="radio" name="bitcoin_rate" id="bitcoin-rate-down" value="down" v-model="direction"
									       :disabled="bidAccepted">
									<label for="bitcoin-rate-down"><img src="../assets/icons/icon-arrow-down-solid.svg" alt="">
										Вниз</label>
								</div>
							</div>
						</div>
					</div>
					<div class="place-bet__agree-rules">
						<input type="checkbox" name="agree_rules" id="agree-rules" :disabled="bidAccepted" required>
						<label for="agree-rules">Я ознакомлен с правилами сервиса.</label>
					</div>
				</div>
				<div class="form-rate__counting">
					<Indexes/>
					<CurrencyConverter/>
				</div>
				<div class="form-rate__footer">
					<button class="btn" type="submit" :disabled="bidAccepted" :class="{ 'is-loading': bidAccepted }">{{
						bidAccepted ? 'Ждём результат' : 'Сделать ставку' }}
					</button>
				</div>
			</form>
		</div>
		<ContentFooter/>
	</div>
</template>

<script>
	import CurrencyConverter from "./CurrencyConverter";
	import ContentFooter from "./ContentFooter";
	import Indexes from "./Indexes";
	import {mapState} from 'vuex'

	export default {
		name:       "BetForm",
		components: {Indexes, ContentFooter, CurrencyConverter},
		data:       function () {
			return {
				errors:    [],
				currency:  'USD',
				amount:    0,
				direction: '',
			}
		},
		computed:   {
			...mapState({
				currencies:      state => state.indexes.rates,
				bidAccepted:     state => state.indexes.bidAccepted,
				convertedAmount: state => state.indexes.convertedAmount,
				balance:         state => state.user.balance
			}),
		},
		methods:    {
			checkForm:        function () {
				this.checkAmountInput();
				if (!this.errors.length) {
					this.$store.dispatch('indexes/setBid', [this.currency, this.amount, this.direction])
				}
			},
			checkAmountInput: function () {
				this.errors = [];
				if (Number.isNaN(Number(this.amount))) {
					this.errors.push('Только численные значения');
				}
				else if (Number(this.amount) <= 0) {
					this.errors.push('Только больше 0');
				}
				else {
					this.$store.dispatch('indexes/calculateConvertedAmount', [this.currency, this.amount])
				}
				if (Number(this.balance) < Number(this.convertedAmount)) {
					this.errors.push('Не хватает средств');
				}
				if (this.errors.length) {
					this.$store.dispatch('indexes/calculateConvertedAmount', [this.currency, 0])
				}
			}
		}
	}
</script>
